import React, { useState } from 'react';

import { GtpWalletInfoResult } from '@eika-infrastruktur/mobilbank-lib';
import { FormContainer } from '@eika-kortbetjening/form-container';
import { LinkButton } from '@eika/button';

import { GooglePayData } from '@/domain/digital-wallet/types';
import useText from '@/hooks/use-text';
import piwik from '@/piwik/piwik';

import CustomerCard from '@components/customer-card/CustomerCard';
import { useNavigate } from '@domain/app';
import { goToRoot } from '@utils/url-utils';

import PermissionConfirmModal from '../permission-confirm-modal/PermissionConfirmModal';
import { CardInformation } from './card-information/CardInformation';
import { GooglePayActivationStatusAndOnboardingControl } from './google-pay-activation-status-and-onboarding-control/GooglePayActivationStatusAndOnboardingControl';

import './GooglePayActivationForm.scss';

type GooglePayActivationFormContentProps = {
    data: GooglePayData;
    googleWalletInfo: GtpWalletInfoResult;
};

export const GooglePayActivationFormContent = ({ data, googleWalletInfo }: GooglePayActivationFormContentProps) => {
    const { googleWalletAddToGooglePayHeader, googleWalletAddToGooglePayDescription, formCancel } = useText();
    const [showGooglePayActivationPermissionConfirmModal, setShowGooglePayActivationPermissionConfirmModal] =
        useState<boolean>(false);

    const navigate = useNavigate();

    return (
        <>
            <FormContainer>
                <FormContainer.Header
                    title={googleWalletAddToGooglePayHeader}
                    description={googleWalletAddToGooglePayDescription}
                />
                <FormContainer.Content>
                    <div className="google-pay-activation-form-content">
                        <CustomerCard card={data.card} />
                        <CardInformation card={data.card} />
                        <GooglePayActivationStatusAndOnboardingControl
                            data={data}
                            googleWalletInfo={googleWalletInfo}
                            startGooglePayActivationWithSigning={() =>
                                setShowGooglePayActivationPermissionConfirmModal(true)
                            }
                        />
                    </div>
                </FormContainer.Content>
                <FormContainer.Footer>
                    <div>
                        <LinkButton
                            data-track-id={piwik.googlePay.activationFormCancelButton.dataTrackId}
                            data-track-linkname={piwik.googlePay.activationFormCancelButton.dataTrackLinkname}
                            onClick={() => goToRoot(navigate)}
                        >
                            {formCancel}
                        </LinkButton>
                    </div>
                </FormContainer.Footer>
            </FormContainer>
            {data.source === 'te' && (
                <PermissionConfirmModal
                    data={data}
                    setOpen={() => setShowGooglePayActivationPermissionConfirmModal(false)}
                    open={showGooglePayActivationPermissionConfirmModal}
                    googleWalletInfo={googleWalletInfo}
                />
            )}
        </>
    );
};
